import * as React from 'react';
import { View } from 'react-native';
const NativeAvoidSoftInputView = View;
/**
 * Regular View component which is listening for soft input events and manages whether
 * it should avoid soft input
 */

export default class AvoidSoftInputView extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(NativeAvoidSoftInputView, this.props);
  }

}
//# sourceMappingURL=AvoidSoftInputViewCompat.js.map